import DOMPurify from 'dompurify';
import { EditorState, Modifier, ContentState, convertFromHTML } from 'draft-js';

const SPACE = ' ';
const REGEX_NBSP = new RegExp('&nbsp;', 'g');
const REGEX_IMG = new RegExp('<img[^>]*>', 'g');

export const onPastedText = ({ html, editorState, onChange }) => {
  if (html) {
    const sanitizedHtml = html
      .trim()
      .replace(REGEX_NBSP, SPACE)
      .replace(REGEX_IMG, '');

    const safeHtml = DOMPurify.sanitize(sanitizedHtml);

    if (safeHtml) {
      const blockFromHTML = convertFromHTML(safeHtml);

      const insertedContent = ContentState.createFromBlockArray(
        blockFromHTML.contentBlocks,
        blockFromHTML.entityMap
      );

      const newContent = Modifier.replaceWithFragment(
        editorState.getCurrentContent(),
        editorState.getSelection(),
        insertedContent.getBlockMap()
      );

      const newContentWithZeroSpace = Modifier.insertText(
        newContent,
        newContent.getSelectionAfter(),
        '\u200B'
      );

      const newEditorState = EditorState.push(
        editorState,
        newContentWithZeroSpace,
        'insert-characters'
      );

      onChange(newEditorState);

      return 'handled';
    }
  }

  return 'not-handled';
};
